// Common styles for ConfigProductDetails components
import { makeStyles } from "@material-ui/core/styles";

// Input field styles for height and border color
export const inputFieldStyles = {
  // height: 40,
  "& .MuiOutlinedInput-root": {
    // height: 40,
    "& fieldset": {
      borderColor: "#374761",
    },
    "&:hover fieldset": {
      borderColor: "#374761",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#374761",
    },
  },
};

// Common styles that can be used across components
export const useCommonStyles = makeStyles((theme) => ({
  formContainer: {
    padding: theme.spacing(2),
  },
  formTitle: {
    marginBottom: theme.spacing(3),
    fontWeight: 600,
  },
  formField: {
    marginBottom: theme.spacing(2),
    width: "100%",
  },
  select: {
    height: 40,
    "& .MuiOutlinedInput-root": {
      height: 40,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#374761",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#374761",
    },
  },
  inputField: {
    // height: 40,
    "& .MuiOutlinedInput-root": {
      // height: 40,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#374761",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#374761",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#374761",
    },
  },
  tableContainer: {
    marginBottom: theme.spacing(2),
  },
}));

// Common inline styles for Material-UI components
export const commonInlineStyles = {
  input: {
    // height: 40,
  },
  inputProps: {
    style: { height: 40, padding: "0px 14px" },
  },  select: {
    height: 40,
    marginTop: "0px",
  },
  selectMenu: {
    padding: "10px 14px",
  },
  outlinedInput: {
    // height: 40,
    borderColor: "#374761",
  },
  // New styles for table inputs/selects
  tableInput: {
    height: 27,
  },
  tableInputProps: {
    style: { height: 27 },
  },
  tableSelect: {
    height: 27,
  },
};
